import { CreateFeatureFlagDto } from '@/view/pages/feature-flags/models/CreateFeatureFlagDto';

export class UpdateFeatureFlagDto extends CreateFeatureFlagDto {
  constructor(data) {
    super(data);
    this.id = data.id;
  }
}
